
import React, { useEffect, useRef, useState } from 'react';
import Header from './Header';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, FormHelperText, Table, TableRow, TableBody, TableCell, TableContainer, TableHead, Paper, Modal, Box, TablePagination, CircularProgress, IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Swal from 'sweetalert2';
import apiSafibc from '../../axios/axios';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import { useLoginStore } from '../../store/zustend';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { motion } from "motion/react";
import CloseIcon from '@mui/icons-material/Close';
import Estadisticas from './Estadisticas';

const styleCi = {
    position: 'absolute',
    top: '10%',
    left: '50%',
    transform: 'translateX(-50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '75%',
    maxHeight: '80vh', // Limita altura al 80% de la pantalla
    overflowY: 'auto', // Scroll vertical si se excede
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



const Presentacion = () => {

    const [nombreContacto, setNombreContacto] = useState('')
    const [emailContacto, setEmailContacto] = useState('')
    const [telefonoContacto, setTelefonoContacto] = useState('')
    const [textoContacto, setTextoContacto] = useState('')
    const [tipoAhorro, setTipoAhorro] = useState('')
    const [tipoAhorros, setTipoAhorros] = useState([])
    const [ahorro, setAhorro] = useState('')
    const [comienzoAhorro, setComienzoAhorro] = useState('')
    const [comienzaContrato, setComienzaContrato] = useState()
    const [simuladorSubmited, setSimuladorSubmited] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [pagosSimulados, setPagosSimulador] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [simuladorSumaAhorro, setSimuladorSumaAhorro] = useState(0)
    const [simuladorRendimiento, setSimuladorRendimiento] = useState(0)
    const [simuladorTotal, setSimuladorTotal] = useState(0)
    const [circleLoad, setCircleLoad] = useState(false)
    const [ahorradoresCantidad, setAhorradoresCantidad] = useState(200)
    const [contratosCompletados, setContratosCompletados] = useState(120)
    const [infoCargada, setInfoCargada] = useState(false)



    const { loginStore } = useLoginStore()

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // regresar a la primera página
    };

    const navigation = (text, navHeigth) => {
        const sectionRef = document.getElementById(text);
        if (sectionRef) {

            const componente = document.getElementById(text).offsetTop;

            window.scrollTo({
                top: componente - navHeigth,
                behavior: 'smooth',
            });
        }
    }

    const enviarCorreoInfo = () => {

        //enviar formulario de contacto

        let key = ''
        if (!nombreContacto) key = 'nc'
        if (!telefonoContacto || !emailContacto) key = 'tec'
        if (!textoContacto) key = 'tc'

        let mensaje = ''
        switch (key) {
            case 'nc':
                mensaje = 'Tu nombre es necesario para poder pedir informacion!'
                break;
            case 'tec':
                mensaje = 'Tu telefono es necesario para poder pedir informacion!'
                break;
            case 'tc':
                mensaje = 'Tus preguntas son necesarias para poder pedir informacion!'
                break;
        }

        if (mensaje) {
            return Swal.fire({
                icon: 'info',
                title: 'Opss',
                text: mensaje
            })
        }

        const enviarCorreo = async () => {

            try {

                const jInfoContacto = {
                    nombreContacto,
                    telefonoContacto,
                    textoContacto,
                    emailContacto
                }

                const response = await apiSafibc.post('/presentacion/enviar-correo-info-contacto', jInfoContacto, {
                    headers: {
                        'XP1-K3Y': `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })


                Swal.fire({
                    icon: 'success',
                    title: 'Enhorabuena',
                    text: response.data.mensaje
                })

                setNombreContacto('')
                setTelefonoContacto('')
                setEmailContacto('')
                setTextoContacto('')

            } catch (error) {
                console.log(error)
                Swal.fire({
                    icon: 'info',
                    title: 'Opss',
                    text: 'Ocurrio un porblema, vuelva a intentarlo!'
                })
            }

        }

        enviarCorreo()

        //correo: crear correo administracion@safibc.net
        //Safibc123.

    }

    const obtenerInfoPresentacion = async() => {

        const info = async () => {
            try {
                const info_presentacion = await apiSafibc('/presentacion/obtener-info-presentacion', {
                    headers: {
                        'XP1-K3Y': `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setTipoAhorros(info_presentacion.data.tipos_ahorro)
                setAhorradoresCantidad(info_presentacion.data.ahorradores_cantidad)
                setContratosCompletados(info_presentacion.data.contratos_terminados)
                setInfoCargada(true)
            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al obtener tipo de ahorros, volver a cargar pagina por favor!'
                    }
                }
                //mensaje de toastify
                console.log(msg_error)
            }
        }

        await info()

    }

    useEffect(() => {
        obtenerInfoPresentacion()
    }, [])

    const simularAhorro = () => {
        setCircleLoad(true)
        setSimuladorSubmited(true);

        const jSimularAhorro = {
            id_ahorro: tipoAhorro,
            fecha_comienza: comienzaContrato,
            cantidad_ahorrar: ahorro,
            cantidad_inicial: comienzoAhorro
        }

        const simularAhorro = async () => {

            try {

                const simular = await apiSafibc.post('/presentacion/simular-ahorro', jSimularAhorro, {
                    headers: {
                        'XP1-K3Y': `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                //abrir modal con informacion
                setPage(0)
                setPagosSimulador(simular.data.pagos)
                setSimuladorSumaAhorro(simular.data.suma_ahorro)
                setSimuladorRendimiento(simular.data.rendimiento)
                setSimuladorTotal(simular.data.total)
                setCircleLoad(false)
                setTimeout(() => {
                    setOpenModal(true);
                }, 0);

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al simular ahorro, volver a intentarlo!'
                    }
                }
                //mensaje de toastify
                setCircleLoad(false)
                toast.error(msg_error, toast_config)
            }

        }

        simularAhorro()
    }

    function formatoMonedayLetra(value) {
        const formatter = new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2
        })
        return `${formatter.format(value)} MXN`
    }

    return (
        <div>
            <Header eventHandler={navigation} />



            <motion.div
                className='container-fluid m-0 p-0 bg-presentacion'
                id='inicio'
                initial={{ opacity: 0, y: -90 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ amount: 0.3 }}
                transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}
            >
                <motion.p
                    className='text-white p-presentacion font-lato'
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ amount: 0.3 }}
                    transition={{ duration: 0.5, delay: 0.6, easing: "ease-out" }}
                >
                    Salud Financiera
                </motion.p>
            </motion.div>

            <div className='container-fluid py-5 bg-white border-bottom' id='myv'>
                <div className='container'>
                    <div className='row d-flex justify-content-center align-items-center'>



                        {/* Imagen 1 */}
                        <motion.div
                            className='col-md-5 mb-4'
                            initial={{ opacity: 0, y: -50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <img src="/img/visionsfbc.jpeg" alt="" className='img-fluid shadow rounded' />
                        </motion.div>

                        {/* Imagen 2 */}
                        <motion.div
                            className='col-md-5 mb-4'
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <img src="/img/misionsfbc.jpeg" alt="" className='img-fluid shadow rounded' />
                        </motion.div>


                    </div>
                </div>
            </div>


            <div className='container-fluid py-5 bg-light border-bottom'>
                <div className='container'>
                    <div className='row d-flex justify-content-center align-items-center'>

                        {/* Imagen */}
                        <motion.div
                            className='col-md-5 mb-2'
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                        >
                            <img src="/img/img1.jpg" alt="" className='img-fluid shadow rounded' />
                        </motion.div>

                        {/* Texto */}
                        <motion.div
                            className='col-md-5'
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                        >
                            <h3 className='fw-bold'>Tu dinero, en buenas manos.</h3>
                            <span className='text-justify' style={{ fontSize: '18px' }}>
                                Administramos tus ahorros con responsabilidad, confianza y total transparencia.
                                Construye tu futuro financiero con nosotros.
                            </span>
                        </motion.div>

                    </div>
                </div>
            </div>


            <div className='container-fluid py-5 bg-white border-bottom' id='acercade'>
                <div className='container'>
                    <div className='row d-flex justify-content-center align-items-center'>

                        {/* Título */}
                        <motion.div
                            className='col-md-12 mb-4'
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                        >
                            <h2 className='text-center fw-bold'>Acerca de</h2>
                        </motion.div>

                        {/* Texto */}
                        <motion.div
                            className='col-md-5 mb-4'
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
                        >
                            <h3 className='fw-bold'>Evita los errores que frenan tu crecimiento financiero.</h3>
                            <span className='text-justify' style={{ fontSize: '18px' }}>
                                En Salud Financiera Integral BC, te ayudamos a cuidar y hacer crecer tus ahorros, evitando los errores más comunes que impiden prosperar.
                                Porque el primer paso hacia la libertad financiera… es dejar de tropezar con lo mismo.
                            </span>
                        </motion.div>

                        {/* Imagen */}
                        <motion.div
                            className='col-md-5 mb-4'
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
                        >
                            <img src="/img/acercade.jpeg" alt="" className='img-fluid shadow rounded' />
                        </motion.div>

                    </div>
                </div>
            </div>

            <div className='container-fluid py-5 bg-light border-bottom' id='ahorros'>
                <div className='container'>
                    <div className='row d-flex justify-content-center'>

                        {/* Imagen de Ahorros */}
                        <motion.div
                            className='col-md-10'
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ amount: 0.3 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                        >
                            <img src="/img/ahorros.png" alt="" className='img-fluid rounded' />
                        </motion.div>

                    </div>
                </div>
            </div>

            {infoCargada && (  
                <Estadisticas clientes={ahorradoresCantidad} contratos_completados={contratosCompletados} />
            )}
            

            <motion.div
                className='container-fluid py-5 bg-light border-bottom'
                id='simulador'
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ amount: 0.3 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
            >
                <div className='container'>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-md-8'>
                            <div className='card shadow border-0'>
                                <div className='card-header text-white fw-bold fs-3' style={{ background: '#025A8C' }}>
                                    <span><CurrencyExchangeIcon fontSize="large" /> Simulador</span>
                                </div>
                                <div className='card-body m-2'>
                                    <div className='row'>
                                        {/* Tipo de Ahorro */}
                                        <div className='col-md-10 mb-3'>
                                            <FormControl variant="standard" sx={{ minWidth: '100%' }} error={simuladorSubmited && !tipoAhorro}>
                                                <InputLabel id="standard-label" style={{ fontSize: '18px' }}>Tipo de Ahorro</InputLabel>
                                                <Select
                                                    labelId="standard-label"
                                                    id="select-standard"
                                                    value={tipoAhorro}
                                                    onChange={(e) => setTipoAhorro(e.target.value)}
                                                    label="Tipo de Ahorro"
                                                    style={{ fontSize: '18px' }}
                                                >
                                                    {tipoAhorros && tipoAhorros.map(ta => (
                                                        <MenuItem value={ta.id_ahorro} key={ta.id_ahorro} style={{ fontSize: '18px' }}>
                                                            {ta.descripcion}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {simuladorSubmited && !tipoAhorro && (
                                                    <FormHelperText style={{ fontSize: '16px' }}>Este campo es obligatorio</FormHelperText>
                                                )}
                                            </FormControl>
                                        </div>

                                        {/* Cantidad a Ahorrar */}
                                        <div className='col-md-6 mb-3'>
                                            <TextField
                                                helperText={simuladorSubmited && !ahorro ? 'Este campo es obligatorio' : ''}
                                                error={simuladorSubmited && !ahorro}
                                                onChange={(e) => setAhorro(Number(e.target.value))}
                                                value={ahorro}
                                                type='number'
                                                id="standard-basic"
                                                style={{ width: '100%', fontSize: '18px' }}
                                                label="Cantidad a Ahorrar"
                                                variant="standard"
                                                InputLabelProps={{ style: { fontSize: '18px' } }}
                                                InputProps={{ style: { fontSize: '18px' } }}
                                            />
                                        </div>

                                        {/* Cantidad Inicial */}
                                        <div className='col-md-6 mb-3'>
                                            <TextField
                                                helperText={simuladorSubmited && (comienzoAhorro === '' || comienzoAhorro == null) ? 'Este campo es obligatorio' : ''}
                                                error={simuladorSubmited && (comienzoAhorro === '' || comienzoAhorro == null)}
                                                onChange={(e) => setComienzoAhorro(Number(e.target.value))}
                                                value={comienzoAhorro}
                                                type='number'
                                                id="standard-basic-2"
                                                style={{ width: '100%', fontSize: '18px' }}
                                                label="Cantidad Inicial a Ahorrar"
                                                variant="standard"
                                                InputLabelProps={{ style: { fontSize: '18px' } }}
                                                InputProps={{ style: { fontSize: '18px' } }}
                                            />
                                        </div>

                                        {/* Fecha de inicio */}
                                        <div className='col-md-12 mb-3'>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={comienzaContrato}
                                                    label='Comienzo de Contrato'
                                                    variant='standard'
                                                    onChange={(value) => setComienzaContrato(value)}
                                                    slotProps={{
                                                        textField: {
                                                            helperText: simuladorSubmited && !comienzaContrato ? 'Este campo es obligatorio' : 'MM/DD/YYYY',
                                                            variant: 'standard',
                                                            error: simuladorSubmited && !comienzaContrato,
                                                            InputLabelProps: { style: { fontSize: '18px' } },
                                                            InputProps: { style: { fontSize: '18px' } },
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </div>

                                        {/* Botón */}
                                        <div className='col-md-12 mb-3'>
                                            <Button
                                                variant='outlined'
                                                onClick={simularAhorro}
                                                disabled={!tipoAhorro || !ahorro || comienzoAhorro === '' || comienzoAhorro == null || !comienzaContrato || circleLoad}
                                                style={{ fontSize: '18px' }}
                                            >
                                                {!circleLoad ? 'Simular' : <CircularProgress size={25} />}
                                            </Button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
                className='container-fluid py-5 bg-white border-bottom'
                id='contacto'
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }} // se activa al 30% visible y puede repetirse
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <div className='container'>
                    <div className='row d-flex justify-content-center'>
                        <motion.div
                            className='col-md-6'
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                        >
                            <div className='card border-0 shadow'>
                                <div className='card-body'>
                                    <motion.h2
                                        className='text-center fw-bold'
                                        initial={{ opacity: 0, y: -20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <ContactMailIcon /> Contacto
                                    </motion.h2>

                                    <form action="" className='row'>
                                        {[
                                            { value: nombreContacto, onChange: (x) => setNombreContacto(x.target.value.toUpperCase()), label: "Nombre Completo", full: true },
                                            { value: emailContacto, onChange: (x) => setEmailContacto(x.target.value.toUpperCase()), label: "E-mail", full: false },
                                            { value: telefonoContacto, onChange: (x) => setTelefonoContacto(x.target.value.toUpperCase()), label: "Teléfono", full: false },
                                            { value: textoContacto, onChange: (x) => setTextoContacto(x.target.value.toUpperCase()), label: "¿Cómo podemos ayudarte?", full: true, multiline: true, rows: 2 }
                                        ].map((field, index) => (
                                            <motion.div
                                                key={field.label}
                                                className={`col-md-${field.full ? '12' : '6'} mb-2`}
                                                initial={{ opacity: 0, y: 20 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                                viewport={{ once: false, amount: 0.3 }}
                                                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                                            >
                                                <TextField
                                                    value={field.value}
                                                    onChange={field.onChange}
                                                    multiline={field.multiline || false}
                                                    rows={field.rows || 1}
                                                    id="outlined-basic"
                                                    label={field.label}
                                                    variant="standard"
                                                    style={{ width: '100%' }}
                                                    required
                                                />
                                            </motion.div>
                                        ))}

                                        <motion.div
                                            className='col-md-12 mb-2 d-flex justify-content-center'
                                            initial={{ opacity: 0, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: false, amount: 0.3 }}
                                            transition={{ duration: 0.5, delay: 0.6 }}
                                        >
                                            <Button
                                                variant="contained"
                                                style={{ width: '50%' }}
                                                endIcon={<SendIcon />}
                                                onClick={enviarCorreoInfo}
                                            >
                                                Enviar
                                            </Button>
                                        </motion.div>

                                    </form>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </motion.div>

            <motion.div
                className='container-fluid'
                style={{ backgroundColor: '#025a8c' }}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }} // se activa al 30% visible y se puede repetir
                transition={{ duration: 0.7, ease: "easeOut" }}
            >
                <div className='row'>
                    <motion.div
                        className='col-md-12 m-0 p-0'
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6718.194759843955!2d-115.45412822491593!3d32.65685267371405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d771cedc75818d%3A0x600206839af1c9c2!2sWorkaholic!5e0!3m2!1ses!2sus!4v1750736476702!5m2!1ses!2sus"
                            width="100%"
                            height="450"
                            style={{ border: '0' }}
                            loading="lazy"
                        ></iframe>
                    </motion.div>
                </div>
            </motion.div>

            <motion.div
                className='container-fluid py-4'
                style={{ backgroundColor: '#025a8c' }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <div className='row d-flex justify-content-center'>
                    <motion.div
                        className='col-md-8 text-center'
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ staggerChildren: 0.1 }}
                    >
                        {[
                            { icon: "fa-brands fa-facebook fa-2xl m-2 shadow text-light" },
                            { icon: "fa-brands fa-instagram fa-2xl m-2 shadow text-light" }
                        ].map((item, index) => (
                            <motion.i
                                key={index}
                                className={item.icon}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            />
                        ))}
                    </motion.div>
                </div>
            </motion.div>


            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
                >
                    <Box sx={styleCi}>

                        <div className='nav-header2 pt-4'></div>
                        <div className='card border-0'>
                            <div className='card-header text-center'>
                                <h3 style={{ fontSize: '24px', fontWeight: 'bold' }}>Pagos Ahorro</h3>
                                <IconButton
                                    onClick={() => setOpenModal(false)}
                                    sx={{ position: 'absolute', top: 8, right: 8 }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <div className='card-body m-2'>
                                {comienzoAhorro > 0 && (
                                    <TextField
                                        inputProps={{
                                            readOnly: true,
                                            style: { fontWeight: 'bold', fontSize: '18px' }
                                        }}
                                        InputLabelProps={{
                                            style: { fontWeight: 'bold', fontSize: '18px' }
                                        }}
                                        variant='standard'
                                        className='mb-3'
                                        value={formatoMonedayLetra(comienzoAhorro)}
                                        label='Con una cantidad inicial de'
                                    />
                                )}

                                <TableContainer component={Paper} className='mb-3'>
                                    <Table sx={{ minWidth: 700 }} aria-label="customized table" className="animation-layout">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell><CalendarMonthIcon style={{ fontSize: '22px' }} /></StyledTableCell>
                                                <StyledTableCell><MonetizationOnIcon style={{ fontSize: '22px' }} /></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {pagosSimulados && pagosSimulados
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((p, i) => (
                                                    <StyledTableRow key={i}>
                                                        <StyledTableCell className='fw-bold' style={{ fontSize: '18px' }}>{p}</StyledTableCell>
                                                        <StyledTableCell className='fw-bold' style={{ fontSize: '18px' }}>
                                                            {formatoMonedayLetra(ahorro)}
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={pagosSimulados.length}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        rowsPerPageOptions={[5, 10]}
                                        labelRowsPerPage="Registros por página"
                                        sx={{ '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': { fontSize: '16px' } }}
                                    />
                                </TableContainer>

                                {/* Resumen */}
                                {[
                                    { label: 'Suma Ahorro', value: simuladorSumaAhorro },
                                    { label: 'Rendimiento', value: simuladorRendimiento },
                                    { label: 'Total', value: simuladorTotal }
                                ].map((item, idx) => (
                                    <TextField
                                        key={idx}
                                        inputProps={{ readOnly: true, style: { fontWeight: 'bold', fontSize: '18px' } }}
                                        InputLabelProps={{ style: { fontWeight: 'bold', fontSize: '18px' } }}
                                        value={`${item.value} MXN`}
                                        className='m-3'
                                        style={{ width: '25%' }}
                                        label={item.label}
                                        variant="standard"
                                    />
                                ))}

                            </div>
                        </div>
                    </Box>
                </motion.div>
            </Modal>


            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>
    )
}

export default Presentacion
